import { Mark } from '@tiptap/core'

const TextTransform = Mark.create({
  name: 'textTransform',

  addOptions () {
    return {
      textTransform: null
    }
  },

  addAttributes () {
    return {
      textTransform: {
        default: null,
        parseHTML: element => {
          return element.style.textTransform || element.getAttribute('data-text-transform') || null
        },
        renderHTML: attrs => {
          if (!attrs.textTransform) {
            return {}
          }

          return {
            style: `text-transform:${attrs.textTransform};`
          }
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        style: 'text-transform'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      textTransform: attrs => ({ commands }) => {
        const value = attrs && attrs.textTransform ? attrs.textTransform : null

        if (!value) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, { textTransform: value })
      }
    }
  }
})

export default TextTransform
